import StopScheduledReportSuccessModal from './StopScheduledReportSuccessModal';

export default StopScheduledReportSuccessModal;
